/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rich_Dark_Heron_WadeInputs */

const en_rich_dark_heron_wade = /** @type {(inputs: Rich_Dark_Heron_WadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Section text settings`)
};

const de_rich_dark_heron_wade = /** @type {(inputs: Rich_Dark_Heron_WadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abschnittstext Einstellungen`)
};

/**
* | output |
* | --- |
* | "Section text settings" |
*
* @param {Rich_Dark_Heron_WadeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rich_dark_heron_wade = /** @type {((inputs?: Rich_Dark_Heron_WadeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rich_Dark_Heron_WadeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rich_dark_heron_wade(inputs)
	return de_rich_dark_heron_wade(inputs)
});